export type TSize = 'none' | 's' | 'm' | 'l' | 'xl' | 'xxl';
export type TColorRole = 'grey-superLight' | 'grey-light' | 'grey-normal' | 'grey-dark' | 'success' | 'error' | 'accent-blue' | 'accent-orange' | 'accent-green' | 'white' | 'dark' | 'dark-secondary';
export type TButtonSize = 'extraSmall' | 'small' | 'smallWide' | 'medium' | 'large';
export type TTitleSize = 's' | 'm' | 'l' | 'xl';
export type TDirection = 'v' | 'h';
export type TPosition = 'start' | 'center' | 'end' | 'between';

// $color-inProGrey-25:#f7f7f7;
// $color-inProGrey-50:#ededed;
// $color-inProGrey-100:#d7d7d7;

export const colorMap: Record<TColorRole, string> = {
    'grey-superLight': '#f7f7f7',
    'grey-light': '#ededed',
    'grey-normal': '#bebfbf',
    'grey-dark': '#6c6f70',
    success: '#77b800',
    error: '#e1142c',
    'accent-blue': '#002878',
    'accent-orange': '#f07b05',
    'accent-green': '#77b800',
    white: '#fff',
    dark: '#242424',
    'dark-secondary': '#353535',
};
